import { render, staticRenderFns } from "./ValidadeArquivo.vue?vue&type=template&id=04429aa4&"
import script from "./ValidadeArquivo.vue?vue&type=script&lang=js&"
export * from "./ValidadeArquivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports